module.exports = __webpack_public_path__ + "img/9788976962799.fdcdf372.jpg";